import React, { useState, useEffect } from 'react'
import './FaultSecondPageCustom_bus.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';

export default function FaultSecondPageKpis_Bus(props) {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [faultCount, setFaultCount] = useState(0);
    const [alarmCount, setAlarmCount] = useState(0);
    const [DTCCount, setDTCCount] = useState(0);
    const [faultCountDsnt, setFaultCountDsnt] = useState(0);
    const [alarmCountDsnt, setAlarmCountDsnt] = useState(0);
    const [DTCCountDsnt, setDTCCountDsnt] = useState(0);
    const [timeDuration, setTimeDuration] = useState(0);
    const [chasisDetails, setChasisDetails] = useState([]);

    const resFaultCntDsnt = (data) => {
        setFaultCount(data.Alarm_count.value)
        setFaultCountDsnt(data.UniqueSignal.value)
    };
    const resAlarmCntDsnt = (data) => {
        setAlarmCount(data.Alarm_count.value);
        setAlarmCountDsnt(data.UniqueSignal.value)
    };
    const resDTCCntDsnt = (data) => {
        setDTCCount(data.Alarm_count.value)
        setDTCCountDsnt(data.UniqueSignal.value)
    };
    const resTimeDuration = (data) => {
        setTimeDuration(data[0].duration.value)
    };
    const resChasisDetails = (data) => {
        setChasisDetails(data[0]._source)
    };

    useEffect(() => {
        let body = { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO }
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countDTC_bus', body: body }, resDTCCntDsnt);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countFaultActiveDuration', body: body }, resTimeDuration);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/global_filter', body: body }, resChasisDetails);
        fetchData({ url: API_URL_MAIN + 'faultSecondpage_bus/countUniqueAlarm', body: body }, resAlarmCntDsnt);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countDistinctDTC_bus', body: body }, resFaultCntDsnt);
    }, [props])

    function toTime(minutes) {
        var h = Math.floor(minutes / 3600);
        var m = minutes % 60;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        return `${h}h ${m}min`
    }

    return (
        <>
            <section className="headBG my-2 p-2">
                <div className="row d-flex align-items-center">
                    <div className="col-md-3"><strong>Chassis No:</strong>
                        {chasisDetails.vehicleId}
                    </div>
                    <div className="col-md-3"><strong>City:</strong>
                        {chasisDetails.DLR_ORG_CITY}
                    </div>
                    <div className="col-md-3"><strong>LOB:</strong>
                        {chasisDetails.LOB}
                    </div>
                    <div className="col-md-3"><strong>PPL:</strong>
                        {chasisDetails.PPL}
                    </div>
                </div>
            </section>
            <section className="kpi my-3">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-12 col-lg-12">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{props.counterSignal}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/DTC_count.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{DTCCount}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>DTC Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{faultCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/EV-Logo_iconB.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{faultCount}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Fault Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="float-end" style={{ paddingLeft: "5px", fontSize: "11px" }}>&nbsp;<b></b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/fault_active_duration.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{toTime((timeDuration).toFixed(0))}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Fault Active Time Duration</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{alarmCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/alarm_count.png"} />
                                        </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0">{alarmCount}</p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Alarm Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
